import type { ListCampaignsParams } from '../api/campaignsApi';
import type { ListCouponsParams } from '../api/couponsApi';
import type { ListPromotionAuditParams, ListPromotionsParams } from '../api/promotionsApi';
import type { ListProductSetsParams } from '../api/productSetsApi';
import type { SearchProductsParams } from '../api/refApi';

/** Centralised query keys; everything sits under the `promo` root so a tenant switch can drop it all. */
export const PROMO_ROOT_KEY = 'promo';

export const promoKeys = {
  all: [PROMO_ROOT_KEY] as const,

  campaigns: [PROMO_ROOT_KEY, 'campaigns'] as const,
  campaignsList: (params: ListCampaignsParams) => [PROMO_ROOT_KEY, 'campaigns', 'list', params] as const,
  campaign: (id: string) => [PROMO_ROOT_KEY, 'campaigns', 'detail', id] as const,

  promotions: [PROMO_ROOT_KEY, 'promotions'] as const,
  promotionsList: (params: ListPromotionsParams) =>
    [PROMO_ROOT_KEY, 'promotions', 'list', params] as const,
  promotion: (id: string) => [PROMO_ROOT_KEY, 'promotions', 'detail', id] as const,
  promotionAudit: (id: string, params: ListPromotionAuditParams) =>
    [PROMO_ROOT_KEY, 'promotions', 'audit', id, params] as const,
  promotionStats: (id: string) => [PROMO_ROOT_KEY, 'promotions', 'stats', id] as const,

  productSets: [PROMO_ROOT_KEY, 'product-sets'] as const,
  productSetsList: (params: ListProductSetsParams) =>
    [PROMO_ROOT_KEY, 'product-sets', 'list', params] as const,
  productSet: (id: string) => [PROMO_ROOT_KEY, 'product-sets', 'detail', id] as const,

  coupons: [PROMO_ROOT_KEY, 'coupons'] as const,
  couponsList: (params: ListCouponsParams) => [PROMO_ROOT_KEY, 'coupons', 'list', params] as const,
  coupon: (id: string) => [PROMO_ROOT_KEY, 'coupons', 'detail', id] as const,
  couponCodes: (id: string) => [PROMO_ROOT_KEY, 'coupons', 'codes', id] as const,

  budget: (id: string) => [PROMO_ROOT_KEY, 'budgets', 'detail', id] as const,
  budgetBurn: (id: string) => [PROMO_ROOT_KEY, 'budgets', 'burn', id] as const,

  stackingPolicy: [PROMO_ROOT_KEY, 'stacking-policy'] as const,
  protectionPolicy: [PROMO_ROOT_KEY, 'protection-policy'] as const,

  // Reference data
  productSearch: (params: SearchProductsParams) => [PROMO_ROOT_KEY, 'ref', 'products', params] as const,
  categories: [PROMO_ROOT_KEY, 'ref', 'categories'] as const,
  salesChannels: [PROMO_ROOT_KEY, 'ref', 'sales-channels'] as const,
  customerGroups: [PROMO_ROOT_KEY, 'ref', 'customer-groups'] as const,
} as const;
